const billingTypes = {
  GET_PARTNERS_BILLABLE_AMOUNT: 'GET_PARTNERS_BILLABLE_AMOUNT',
  GET_PATIENTS_TRANSACTIONS: 'GET_PATIENTS_TRANSACTIONS',
  GET_TOTAL_BOOKED_REVENUE: 'GET_TOTAL_BOOKED_REVENUE',
  GET_TOTAL_COLLECTED_REVENUE: 'GET_TOTAL_COLLECTED_REVENUE'
};

export default billingTypes;
